import * as Sentry from '@sentry/react';
import { Dolan, DolanV4 } from '@sapappgyver/appgyver-descriptors/lib/dolan';
import { ILogger as DescriptorMigrationLogger } from '@sapappgyver/appgyver-descriptors/lib/dolan/migration/types';
import migrateDescriptor from '@sapappgyver/appgyver-descriptors/lib/dolan/migration/migrateDescriptor';

const SUPPORTED_DOLAN_VERSION = 4;

const migrationLogger: DescriptorMigrationLogger = {
  info: () => {},
  warn: (message, payload) => {
    // eslint-disable-next-line no-console
    console.warn(message, payload);
    Sentry.captureMessage(message, { level: 'warning', ...payload });
  },
  error: (message, payload) => {
    // eslint-disable-next-line no-console
    console.error(message, payload);
    Sentry.captureException(payload);
  },
};

export default function ensureDescriptorIsLatestSupportedVersion(descriptor: Dolan): DolanV4 {
  try {
    const migratedDescriptor = migrateDescriptor(descriptor, {
      toVersion: SUPPORTED_DOLAN_VERSION,
      logger: migrationLogger,
    });
    if (migratedDescriptor.dolan_version !== SUPPORTED_DOLAN_VERSION) {
      throw new Error('Failed to migrate descriptor to the latest supported version');
    }
    return migratedDescriptor;
  } catch (e) {
    Sentry.captureException(e);
    throw e;
  }
}
